<template>
    <div v-if="showMap" class="c-o-request-section__inner">
        <div class="c-o-request-section__map">
            <iframe width="600"
                height="320"
                frameborder="0"
                style="border:0"
                :src="`https://www.google.com/maps/embed/v1/place?&q=${mapAddress},${mapRegion}&zoom=15&key=${apiKey}`"
                allowfullscreen>
            </iframe>
        </div>
    </div>
</template>

<script>

    import config from '../../../../config';

    export default {
        props: [
            'address',
            'region'
        ],
        computed: {
            apiKey: function() {
                return config.googleMapsApiKey
            },
            mapAddress: function(){
                return this.address.split(' ').join('+');
            },
            mapRegion: function(){
                return this.region.Name.split(' ').join('+');
            },
            showMap: function() {
                return this.address && this.region.Name ? true : false
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/request-sections/OrganismRequestMap.vue